export {default} from "./omdb";


// WEBPACK FOOTER //
// ./src/components/omdb/index.js